import { render, staticRenderFns } from "./SocialProofProduct.vue?vue&type=template&id=1edc23df&scoped=true"
import script from "./SocialProofProduct.js?vue&type=script&lang=js&external"
export * from "./SocialProofProduct.js?vue&type=script&lang=js&external"
import style0 from "./SocialProofProduct.scss?vue&type=style&index=0&id=1edc23df&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc23df",
  null
  
)

export default component.exports